import Vue from 'vue';

class NotificationService {
  notify(options) {
    Vue.prototype.$notifications.notify({
      horizontalAlign: 'right',
      verticalAlign: 'top',
      ...options,
    });
  }

  info(message) {
    this.notify({
      icon: 'fa fa-info',
      type: 'info',
      message,
    });
  }

  success(message) {
    this.notify({
      icon: 'fa fa-check-circle',
      type: 'success',
      message,
    });
  }

  warn(message) {
    this.notify({
      icon: 'fa fa-exclamation-circle',
      type: 'warning',
      message,
    });
  }

  error(message) {
    this.notify({
      icon: 'fa fa-exclamation-circle',
      type: 'danger',
      message,
    });
  }
}

export const notificationService = new NotificationService();
